import { SetPageMerchModule, SetPageProduct } from '@max/common/setpage';
import styled, { css } from 'styled-components';
import { useAnalytics, useAssetsContext } from '../../contexts';
import { MOBILE_SELECTOR } from '../../utils';
import { Button } from '../button';

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

const ButtonWrapper = styled.a<{ $reverse: boolean }>`
  color: var(--set-page-accent-color);
  animation: var(--set-page-accent-animation);
  background-size: var(--set-page-accent-background-size);
  background-color: var(--set-page-accent-background-color);
  background-image: var(--set-page-accent-background-image);
  display: flex;
  text-decoration: none;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 25px;
  overflow: hidden;
  position: relative;
  ${({ $reverse }) =>
    $reverse &&
    css`
      flex-direction: row-reverse;
      & > img {
        rotate: -20deg;
        transform: translate(5px, 5px);
      }
    `}
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  gap: 5px;
  flex-grow: 1;
`;
const Image = styled.img`
  object-fit: cover;
  aspect-ratio: 1;
  display: block;
  width: 15%;
  rotate: 20deg;
  scale: 1.2;
  transform: translate(-5px, 5px);
  border: 3px solid #ffffff;
`;
const Text = styled.div`
  font-size: 22px;
  font-weight: 600;

  @container (${MOBILE_SELECTOR}) {
    font-size: 18px;
  }
`;

const Description = styled.div`
  font-size: 16px;

  @container (${MOBILE_SELECTOR}) {
    font-size: 12px;
  }
`;

interface ListLayoutProps {
  module: SetPageMerchModule;
  merch: SetPageProduct[];
  layout: string;
}

export const ListLayout = ({ module, merch, layout }: ListLayoutProps) => {
  const { track } = useAnalytics();
  const { assetUrl } = useAssetsContext();

  return (
    <List>
      {merch.map((item, index) => (
        <ButtonWrapper
          data-aos="set-page-fade-right"
          key={index}
          $reverse={layout === 'image-buttons-left'}
          href={item.link}
          rel="noopener noreferrer"
          target="_blank"
          onClick={() => track?.({ type: 'click', id: item.id })}
        >
          <Content>
            <Text>{item.title}</Text>
            {!!item.price && <Description>{item.price}</Description>}
          </Content>
          <Image src={assetUrl({ url: item.photo })} />
        </ButtonWrapper>
      ))}
      {module.displayMerchStoreButton &&
        module.merchStoreButtonText &&
        module.merchStoreButtonUrl && (
          <Button
            data-aos="set-page-fade-up"
            as="a"
            href={module.merchStoreButtonUrl}
            target="_blank"
            rel="noreferrer"
            onClick={() => track?.({ type: 'click', id: module.id })}
          >
            {module.merchStoreButtonText}
          </Button>
        )}
    </List>
  );
};
